// @flow
import { useQuery } from 'react-query';
import type { QueryOptions, UseQueryResult } from 'react-query';
import AffordaPortalDetailService from '../../services/affordaPortalDetailService';

type AffordaPortalDetail = {
  [string]: mixed,
};

type Params = {
  organizationId: ?string,
  propertyId: ?string,
  portalUserId: ?string,
  options?: QueryOptions<?AffordaPortalDetail, mixed, ?AffordaPortalDetail>,
};

export default function useAffordaPortalDetailQuery({
  organizationId,
  propertyId,
  portalUserId,
  options = {},
}: Params): UseQueryResult<?AffordaPortalDetail, mixed> {
  const queryKey = [
    'useAffordaPortalDetailQuery',
    organizationId,
    propertyId,
    portalUserId,
  ];

  const enabled =
    !!organizationId &&
    !!propertyId &&
    !!portalUserId &&
    options.enabled !== false;

  return useQuery(
    queryKey,
    async () => {
      if (!organizationId || !propertyId || !portalUserId) {
        return null;
      }

      const service = new AffordaPortalDetailService();
      return service.getByPortalUserId(
        organizationId,
        propertyId,
        portalUserId,
      );
    },
    {
      ...options,
      enabled,
      refetchOnWindowFocus: false,
    },
  );
}
